/** Let checkout and personalization controls take priority over the Postscript teaser. */
(() => {
  if (window.pupRingPostscriptGuard) return;
  window.pupRingPostscriptGuard = true;

  const protectedSelector = '[data-photo-upload-block], .product-content form[action*="/cart/add"], .product-content [role="alert"], #sticky-atc.show, #footer-scroll-top.btn-show';
  const dialogSelector = '.modal.show, .offcanvas.show, .offcanvas.showing, .offcanvas.hiding, [aria-modal="true"], dialog[open]';
  let frame = 0;
  let widget;
  const viewport = window.visualViewport;

  function visible(element) {
    const style = getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' &&
      Number(style.opacity) !== 0 && rect.width > 0 && rect.height > 0 &&
      rect.bottom > 0 && rect.top < window.innerHeight;
  }

  function update() {
    frame = 0;
    const current = document.getElementById('ps__widget');
    if (current !== widget) {
      if (widget) {
        widget.removeAttribute('data-pupring-obscured');
        resizeObserver?.unobserve(widget);
      }
      widget = current;
      if (widget) resizeObserver?.observe(widget);
    }
    if (!widget) return;

    const rect = widget.getBoundingClientRect();
    const modalOpen = [...document.querySelectorAll(dialogSelector)].some(visible);
    // Expanded signup UI owns its screen space; only the compact teaser yields to page content.
    const compact = rect.height <= window.innerHeight / 2;
    const typing = matchMedia('(max-width: 767px) and (pointer: coarse)').matches &&
      document.activeElement?.matches('input:not([type="button"]):not([type="submit"]):not([type="checkbox"]):not([type="radio"]):not([type="file"]):not([type="range"]):not([type="color"]), textarea, [contenteditable="true"]');
    const obstructs = compact && [...document.querySelectorAll(protectedSelector)].some(element => {
      if (!visible(element)) return false;
      const target = element.getBoundingClientRect();
      return rect.left < target.right && rect.right > target.left &&
        rect.top < target.bottom && rect.bottom > target.top;
    });
    widget.toggleAttribute('data-pupring-obscured', modalOpen || (compact && typing) || obstructs);
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(update);
  }

  const resizeObserver = window.ResizeObserver ? new ResizeObserver(schedule) : null;
  const observer = new MutationObserver(schedule);
  function start() {
    observer.observe(document.body, { subtree: true, childList: true, attributes: true,
      attributeFilter: ['class', 'style', 'open', 'aria-hidden', 'aria-modal', 'hidden'] });
    schedule();
  }
  document.addEventListener('scroll', schedule, { passive: true, capture: true });
  document.addEventListener('focusin', schedule);
  document.addEventListener('focusout', schedule);
  document.addEventListener('transitionend', schedule);
  document.addEventListener('load', schedule, true);
  document.fonts?.addEventListener('loadingdone', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  viewport?.addEventListener('resize', schedule, { passive: true });
  viewport?.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('pagehide', () => {
    observer.disconnect();
    resizeObserver?.disconnect();
    cancelAnimationFrame(frame);
    frame = 0;
    widget?.removeAttribute('data-pupring-obscured');
    widget = null;
  });
  window.addEventListener('pageshow', start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
